/* eslint-disable react/prefer-stateless-function */
// Third-party
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';

// Components
import { EditPortfolio } from '../../components/edit-portfolio';

// Redux
import { ReduxState } from '../../../redux/modules/types';
import { savePortfolio, resetPortfolio } from '../../../redux/modules/edit-portfolio';
import { removeItem, replacePortfolioInComparison } from '../../../redux/modules/comparison';

// Utils
import { formatMessage } from '../../../utils/i18n';
import { portfolioIsNew } from '../../../utils/portfolios';
import { getPortfolioMissingOrInvalidHoldings } from '../../../utils/portfolio/utils';
import Portfolio from '@/types/portfolio';
import GenericContact from '@/types/generic-contact';

type StateProps = {
  portfolio: Portfolio;
  show: boolean;
};

type DispatchProps = {
  savePortfolio: (portfolio: Portfolio, contact?: GenericContact) => Promise<Portfolio>;
  resetPortfolio: () => void;
  removeItem: (itemId: string) => void;
  replacePortfolioInComparison: (portfolio: Portfolio, replaceId?: string, isIncomeTab?: boolean) => Promise<void>;
};

type Props = StateProps & DispatchProps & RouteComponentProps;

class PinnedEditPortfolio extends Component<Props> {
  onSave = (portfolio: Portfolio) => {
    let tempId: string;
    if (portfolio._id && portfolio._id.startsWith('new-')) {
      tempId = portfolio._id;
    }

    return this.props.savePortfolio(portfolio).then((savedPortfolio: Portfolio) => {
      this.props.resetPortfolio();
      this.props.replacePortfolioInComparison(savedPortfolio, tempId, this.isIncomeTab());
    });
  };

  isIncomeTab = () => this.props.location.pathname.includes('/income');

  onCancel = (portfolio: Portfolio) => {
    if (portfolio._id && portfolio._id.startsWith('new-')) {
      this.props.removeItem(portfolio._id);
    }

    this.props.resetPortfolio();
  };

  render() {
    const { show, portfolio } = this.props;

    if (!show) {
      return null;
    }

    return (
      <EditPortfolio
        className="pinned"
        onSave={this.onSave}
        onCancel={this.onCancel}
        chartsDelay={500}
        saveLabel={portfolioIsNew(portfolio) ? formatMessage('Comparison.AddToComparison') : undefined}
        saveNotification={portfolioIsNew(portfolio) ? formatMessage('HoldingsEditor.Created.PORTFOLIO') : undefined}
        hasMissingHoldings={portfolio === undefined ? false : getPortfolioMissingOrInvalidHoldings(portfolio).length > 0}
      />
    );
  }
}

const mapStateToProps = ({ editPortfolio, comparison }: ReduxState) => ({
  portfolio: editPortfolio.portfolio,
  show: comparison.portfolioEditor.isPinned,
});

const mapDispatchToProps = {
  savePortfolio,
  resetPortfolio,
  removeItem,
  replacePortfolioInComparison,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PinnedEditPortfolio));
